import script from "./OrderPending.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPending.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPending.vue?vue&type=style&index=0&id=42aa96fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42aa96fe"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSpinner,QSeparator});
